import { BookingPurpose } from 'src/@types/Booking';
const fromRest = (data, purpose) => ({
  clinicReferenceId: data.clinic.referenceId,
  locationReferenceId: null,
  practitionerReferenceId: data.mainPractitioner.referenceId,
  practitionerReferenceIds: [data.mainPractitioner.referenceId],
  appointmentBundleReferenceId: purpose === BookingPurpose.Reschedule ? data.referenceId : null,
  treatmentBundleReferenceId: purpose === BookingPurpose.Reschedule ? data.treatmentBundleReferenceId : null
});
export const AppointmentIdsEntity = {
  fromRest
};